/**
 * Safe storage helper to prevent localStorage.clear() from breaking sessions
 */

export function clearAppSession() {
  const keysToRemove = [
    'tenantID',
    'organizationID', 
    'companyID',
    'userType',
    'mspID',
    'mspSlug',
    'selectedPlan',
    'connectedAccounts',
    // Add other app-specific keys but NOT Cognito tokens
  ];
  
  keysToRemove.forEach(key => localStorage.removeItem(key));
}

export function clearTenantSession() {
  const keysToRemove = [
    'tenantID',
    'organizationID',
    'selectedPlan', 
    'connectedAccounts',
  ];
  
  keysToRemove.forEach(key => localStorage.removeItem(key));
}

export function clearCompanySession() {
  const keysToRemove = [
    'companyID',
    'userType',
  ];
  
  keysToRemove.forEach(key => localStorage.removeItem(key));
}

export function clearMSPSession() {
  const keysToRemove = [
    'mspID',
    'mspSlug',
    'userType',
  ];
  
  keysToRemove.forEach(key => localStorage.removeItem(key));
}